import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

/** 組織情報 */
export interface IOrganization {
	orgId: string;
	orgName: string;
}

/** ユーザ情報 */
export interface IProfile {
	loginId: string; // ログインID
	familyNameJa: string; // 姓(日本語)
	firstNameJa: string; // 名(日本語)
	familyNameEn: string; // 姓(英語)
	firstNameEn: string; // 名(英語)
	familyNameZh: string; // 姓(中国語)
	firstNameZh: string; // 名(中国語)
	familyNameKanaJa: string; // フリガナ姓（日本語）
	firstNameKanaJa: string; // フリガナ名（日本語）
	familyNameKanaEn: string; // フリガナ姓（英語）
	firstNameKanaEn: string; // フリガナ名（英語）
	familyNameKanaZh: string; // フリガナ姓（中国語）
	firstNameKanaZh: string; // フリガナ名（中国語）
	seibetu: string; // 性別
	password?: string; // パスワード
	rePassword?: string; // パスワード再入力
	existsImageFile: boolean; // 顔写真のアップロード判定
	deleteImage: boolean; // イメージ削除判定フラグ
	workStartDate: string; // 入社年月日
	userOrgs: IUserOrg[]; // 所属組織管理
	countryCode: string; // 受講場所
	timeZone: string; // 受講タイムゾーン
	lang: string; // 受講言語
	lederUserId: string; // 評価者
	lederUserName: string; // 評価者名
	officeId: string; // 事業所
	employeeCategoryId: string; // 従業員区分
	occupationId: string; // 職種
	birthday: string; // 生年月日
	addressJa: string; // 住所(日本語)
	addressEn: string; // 住所(英語)
	addressZh: string; // 住所(中国語)
	homePhone: string; // 電話番号
	faxNumber: string; // Fax
	email1: string; // メインメール
	email2: string; // サブメール
	careerMemoJa: string; // 経歴等(日本語)
	careerMemoEn: string; // 経歴等(英語)
	careerMemoZh: string; // 経歴等(中国語)
	noteJa: string; // 備考(日本語)
	noteEn: string; // 備考(英語)
	noteZh: string; // 備考(中国語)
	orgs: IManageOrg[]; // 管理対象組織
	groups: IManageGroup[]; // 管理対象グループ
	primaryOrgId: string; // 本務の組織ID
	applyFlg: number; // コース申込み
	idFlg: string; // ログインID無効化
	certification: number; // 認証方法
	createGroupFlg: number; // 新規グループ作成可能
	emCooperationMode: string; // EM連携モード
	emUserSynFlg: string; // 更新フラグ
}

/** 所属組織情報 */
export interface IUserOrg {
	additionalFlg: boolean;
	companyId: string;
	orgId: string;
	orgName: string;
	titleId: string;
	titleName: string;
}

/** 管理組織情報 */
export interface IManageOrg {
	companyId: string;
	id: string;
	name: string;
}

/** 管理グループ情報 */
export interface IManageGroup {
	companyId: string;
	id: string;
	name: string;
}

/** ユーザ情報複製 */
export const cloneProfile = (org: IProfile) => {
	const newObj: IProfile = {
		...org,
	};
	return newObj;
};

/**
 * 保存済みユーザ情報データ設定アクションクリエータ
 */
export const setStoredProfile = actionCreator<{
	value: IProfile;
}>('SET_STORED_PROFILE');

/**
 * 編集中ユーザ情報データ設定アクションクリエータ
 */
export const setEditedProfile = actionCreator<{
	value: IProfile;
}>('SET_EDITED_PROFILE');

/**
 * 国マスタ設定アクションクリエータ
 */
export const setCountryMaster = actionCreator<{
	value: { [code: string]: string };
}>('SET_COUNTRY_MASTER');

/**
 * タイムゾーンマスタ設定アクションクリエータ
 */
export const setTimezoneMaster = actionCreator<{
	value: { [code: string]: string };
}>('SET_TIMEZONE_MASTER');

/**
 * 言語マスタ設定アクションクリエータ
 */
export const setLangMaster = actionCreator<{
	value: { [code: string]: string };
}>('SET_LANG_MASTER');

/**
 * 事業所マスタ設定アクションクリエータ
 */
export const setOfficeMaster = actionCreator<{
	value: { [code: string]: string };
}>('SET_OFFICE_MASTER');

/**
 * 従業員区分マスタ設定アクションクリエータ
 */
export const setEmployeeCategoryMaster = actionCreator<{
	value: { [code: string]: string };
}>('SET_EMPLOYEE_CATEGORY_MASTER');

/**
 * 職種マスタ設定アクションクリエータ
 */
export const setOccupationMaster = actionCreator<{
	value: { [code: string]: string };
}>('SET_OCCUPATION_MASTER');

/**
 * ユーザ情報登録完了フラグ設定アクションクリエータ
 */
export const setSaveProfileCompleteFlg = actionCreator<{
	saveCompleteFlg: boolean;
	needLogoutFlg: boolean;
}>('SET_SAVE_PROFILE_COMPLETE_FLG');

/**
 * ユーザ情報登録完了Loading設定アクションクリエータ
 */
export const setSaveLoadingFlg = actionCreator<{
	loading: boolean;
}>('SET_SAVE_LOADING_FLG');



// WEBPACK FOOTER //
// ./src/actions/profile.ts